<!--
  @description 流程管理-工单查询
  @author puxiaojian
  @date 2018/12/25
-->
<template>
  <div class="queryworkOrder__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('queryworkOrder.creator')" prop="alarmCode">
        <el-input v-model="searchForm.applicant"></el-input>
      </el-form-item>
      <el-form-item :label="$t('queryworkOrder.type')" input-width="auto">
        <g-select v-model="searchForm.orderType" :list="select_type" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('queryworkOrder.status')" input-width="auto">
        <g-select v-model="searchForm.status" :list="select_status" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('queryworkOrder.siteType')" input-width="auto">
        <g-select v-model="searchForm.site" :list="select_host" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" v-model="searchForm.startDate" style="width: 180px;" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" v-model="searchForm.endDate" style="width: 180px;" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          v-g-rac="gRac('queryworkOrder@search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('queryworkOrder@export')"
          @click="e_export" 
          v-text="$t('queryworkOrder.export')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :cell-style="cellStyle"
      :cell-click="cellClick"
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import tab from '@/views/layout/components/setTab'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import exportTips from '@/components/mixins/exportTips'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  const DIC_MAP = {
    site: 'remoteconfig',
    status: 'workflowOrderStatus'
  }

  export default {
    mixins: [rac, dic, table, exportTips],
    data () {
      return {
        searchForm: {
          startDate: new Date(new Date().toLocaleDateString()).getTime(),
          endDate: '',
          applicant: '', // 创建人
          orderType: '', // 工单类型
          status: '', // 状态
          site: '' // 站点
        },
        tableControl: [
          {
            label: this.$t('common.check'),
            callback: (row, index, data) => {
              this.$router.push({
                name: 'reportDetail',
                query: {
                  id: row.id
                }
              })
            },
            rac: () => this.gRac('examinationReport@check')
          }
        ],
        select_host: {},
        select_status: {},
        select_type: {},
        doExport: null
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('remoteconfig'),
          this.dGetDictionaryByCode('workflowOrderStatus'),
          resApplicationBiz.getAll().then(data => {
            let dicObj = {}
            for (let i of data) {
              dicObj[i.templateId] = i.name
            }
            this.select_type = { ...dicObj }
          })
        ])
        this.select_host = { ...this.dDictionary.remoteconfig }
        this.select_status = { ...this.dDictionary.workflowOrderStatus }
        this.initTable()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'queryworkOrder.table',
          head: ['applicant', 'templateId', 'status', 'site', 'startDate', 'endDate', 'currentNode', 'currentAssignee'],
          requestFun: this.searchTable,
          headOpt: {
            templateId: {
              formatter: 'Dictionary',
              formatterDic: this.select_type
            },
            status: {
              formatter: 'Dictionary',
              formatterDic: this.select_status
            },
            site: {
              formatter: 'Dictionary',
              formatterDic: this.select_host
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endDate) reqData.endDate = new Date().getTime()
        queryworkOrderBiz.findOrderByPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.startDate = item.startDate ? TimeFormat.getFormatTime(item.startDate) : ''
              item.endDate = item.endDate ? TimeFormat.getFormatTime(item.endDate) : ''
            })
          }
          this.tData = data
        })
      },
      e_export () {
        const search = extend({}, this.searchForm)
        if (!this.doExport) {
          this.doExport = this.exportTable()
        }
        this.doExport(search)
      },
      exportTable () {
        const that = this
        const list = Object.assign({}, that.$t('queryworkOrder.table'))
        list.reason = this.$t('cloudApplication.reason')
        list.remarks = this.$t('cloudApplication.remark')
        list.users = this.$t('cloudApplication.users')
        const dictionary = []
        for (const key in DIC_MAP) {
          dictionary.push({
            relate: key,
            type: that.dDictionary[DIC_MAP[key]]
          })
        }
        dictionary.push({
          relate: 'templateId',
          type: this.select_type
        })
        return function (search) {
          that.exRenderBefore()
          queryworkOrderBiz.exportOrder(
            list,
            search,
            ['startDate', 'endDate'],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          )
        }
      },
      cellStyle ({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return 'color:#0B8DE5; cursor:pointer'
        }
      },
      cellClick (row, columnKey) {
        if (columnKey === 'templateId') {
          this.jumpOrder(row)
        }
      },
      jumpOrder (res) {
        const filterType = res.orderType
        const filterStatus = Object.keys(this.select_status).filter(item => this.select_status[item] === res.status)[0]
        let routerName = ''
        switch (filterType) {
          // 新开机
          case 'BootupRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'bootUpRequest' : 'bootUpOrder'
            break
          // PAAS初始化
          case 'PaasInitRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'paasInitRequest' : 'paasInitOrder'
            break
          // 业务上线
          case 'ServiceGoLiveRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'serviceRequest' : 'serviceOrder'
            break
          // 关机
          case 'ShutdownRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'shutdownRequest' : 'shutdownOrder'
            break
          // 通用模板
          case 'CommonRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'commonRequest' : 'commonOrder'
            break
          // 主机与数据库权限
          case 'DBPermissionRequestProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'dbPermissionRequest' : 'dbPermissionOrder'
            break
          // 关闭权限
          case 'ClosePermissionProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'closePermissionRequest' : 'closePermissionOrder'
            break
          // 回收权限
          case 'RevokePermissionProcess':
            routerName = (filterStatus === '5' && res.assignee) ? 'revokeRequest' : 'revokeOrder'
            break
          default:
            this.$message.error(this.$t('cloudApplication.processTmlErr'))
        }
        if (routerName) {
          this.$router.push({ name: routerName,
            query: {
              status: filterStatus,
              orderId: res.processInstanceId,
              assignee: res.assignee ? '1' : '0'
            }
          })
          if (routerName.indexOf('Request') > -1) {
            tab.selectTab('cloudApplication')
          }
        }
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'queryworkOrder' && (from.name === 'cloudApplication' ||
          from.name === 'bootUpOrder' ||
          from.name === 'paasInitOrder' ||
          from.name === 'shutdownOrder' ||
          from.name === 'serviceOrder' ||
          from.name === 'commonOrder' ||
          from.name === 'dbPermissionOrder' ||
          from.name === 'closePermissionOrder' ||
          from.name === 'revokeOrder')) {
          this.searchTable()
        }
      }
    },
    mounted () {
      this.preInitTable()
      this.searchTable()
    }
  }
</script>